import Vue from 'vue';
import { Header } from './Components';

const app = new Vue({
    el: '#header-background',
    render: (h) => h(Header),
});
